import React from 'react';
import { useSelector } from 'react-redux';

import { QUOTED } from 'shared/product_tabs/tab_parts/data/BomStatus';
import { valid_buy_options } from 'shared/product_tabs/tab_parts/utils/helpers';
import { extractBomLineItemData } from 'shared/product_tabs/tab_parts/utils/extracters';
import { selectDataForReview } from 'shared/product_tabs/tab_parts/slice/selectors';
import BomItem from 'shared/product_tabs/tab_parts/components/review/BomItem';

const BomReview = ({ onOpenBomModal }) => {
  const { bom_line_items, saved, selected_board_qty, status, markups } =
    useSelector(selectDataForReview);

  if (!saved || status !== QUOTED) return null;

  return (
    <div id='bom-show-table' className='bom-show-table'>
      <div className='row mb-3'>
        <div className='col-12 col-md-9'>
          <div className='align-self-end'>
            <h4 className='fw-bold'>SUMMARY</h4>
            <span className='badge rounded-pill bg-will-provide text-dark border'>
              I will provide
            </span>
            <span className='badge rounded-pill bg-dont-populate text-dark border ml-1'>
              Do not populate
            </span> 
            <span className="badge rounded-pill bg-tariff-may-apply text-dark border ms-1">
              Tariff may apply after purchase
            </span>
          </div>
        </div>
        <div className='col-12 col-md-3 d-flex justify-content-end align-items-end '>
          <button
            type='button'
            className='btn btn-outline-primary bom-file-button ms-auto'
            onClick={onOpenBomModal}>
            Edit BOM
          </button>
        </div>
      </div>
      <div className='table-responsive'>
        <table className='table table-bordered'>
          <thead className='table-primary'>
            <tr>
              <th className=''>#</th>
              <th className=''>Manufacturer Part Number</th>
              <th className=''>Reference Designator</th>
              <th className='bom-description'>Description</th>
              <th className='text-center'>Qty Per Board</th>
              <th className='text-center'>Purchase QTY</th>
              <th className='text-end'>Unit Price</th>
              <th className='text-end'>Ext. Price</th>
               <th className="text-end">Est. Tariff</th>
            </tr>
          </thead>
          <tbody>
            {bom_line_items.map((bli, index) => {
              const { line_in_file } = bli;

              const { identifier, description,  estimated_tariff, tariff_may_be_applied_after_purchase } = extractBomLineItemData(
                bli,
                selected_board_qty,
              );

              const markup_multiplier = 1 + markups[selected_board_qty];
              const qty_to_buy = valid_buy_options.includes(bli.user_action)
                ? bli.qty_to_buy[selected_board_qty]
                : '-';
              const qty_per_board = qty_to_buy !== '-' ? bli.qty : '-';
              const price_by_qty =
                qty_to_buy !== '-' ? bli.price_by_qty[selected_board_qty] : '-';
              const unit_price =
                qty_to_buy !== '-'
                  ? (price_by_qty / qty_to_buy) * markup_multiplier
                  : '-';
              const ext_price =
                qty_to_buy !== '-' ? price_by_qty * markup_multiplier : '-';

              return (
                <BomItem
                  key={`bom-line-item-show-${index}`}
                  user_action={bli.user_action}
                  line_in_file={line_in_file}
                  identifier={identifier}
                  description={description}
                  reference_designator={bli.reference_designator}
                  qty_per_board={qty_per_board}
                  qty_to_buy={qty_to_buy}
                  unit_price={unit_price}
                  price_by_qty={ext_price}
                  estimated_tariff={estimated_tariff}
                  tariff_may_be_applied_after_purchase={tariff_may_be_applied_after_purchase}
                />
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BomReview;
